import { useEffect } from "react";

const useSectionObserver = (setActiveSection) => {
  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleSections = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (window.scrollY === 0) {
          setActiveSection("home");
        } else if (visibleSections.length > 0) {
          const firstVisible = visibleSections[0].target.getAttribute("id");
          requestAnimationFrame(() => setActiveSection(firstVisible));
        }
      },
      {
        threshold: 0.3, // tăng để phát hiện sớm hơn
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [setActiveSection]);
};

export default useSectionObserver;
